import { SaveStep } from '@/saveRegistration/SaveRegistrationProvider.tsx';
import React, { FC } from 'react';
import { useSaveRegistration } from '@/saveRegistration/useSaveRegistration.ts';
import { ICONS } from '@/Icons.tsx';

interface SaveSpinnerProps {
  spinFor: SaveStep;
}

const Unknown = () => {
  return <i className={ICONS.questionmark} />;
};

const Spinner = () => {
  return <i className={ICONS.spinner} />;
};

const Failed = () => {
  return <i className={ICONS.failed} />;
};

const Success = () => {
  return <i className={ICONS.success} />;
};

export const SaveSpinner: FC<SaveSpinnerProps> = ({ spinFor }) => {
  const { gridStatus, onlineStatus, transmitRegistrationStatus, confirmTransmitStatus } = useSaveRegistration();

  switch (spinFor) {
    case 'idle':
      return <Unknown />;
    case 'online-check':
      switch (onlineStatus) {
        case 'unknown':
          return <Spinner />;
        case 'online':
          return <Success />;
        case 'no-backend':
          return <Failed />;
        case 'offline':
          return <Failed />;
        default:
          return <Unknown />;
      }

    case 'grid-check':
      switch (gridStatus) {
        case 'unknown':
          return <Unknown />;
        case 'checking':
          return <Spinner />;
        case 'usable':
          return <Success />;
        case 'used':
          return <Failed />;
        case 'error':
          return <Failed />;
        default:
          return <Unknown />;
      }

    case 'transmit-registration':
      switch (transmitRegistrationStatus) {
        case 'unknown':
          return <Unknown />;
        case 'transmitting':
          return <Spinner />;
        case 'transmitted-success':
          return <Success />;
        case 'transmitted-failure':
          return <Failed />;
        case 'transmitted-unknown-failure':
          return <Failed />;
        default:
          return <Unknown />;
      }

    case 'confirm-transmission':
      switch (confirmTransmitStatus) {
        case 'unknown':
          return <Unknown />;
        case 'confirming':
          return <Spinner />;
        case 'confirmation-success':
          return <Success />;
        case 'confirmation-failure':
          return <Failed />;
        default:
          return <Unknown />;
      }
  }
};
